// extracted by mini-css-extract-plugin
module.exports = {"root":"Animator_root__n3jm8","background-image":"Animator_background-image__1HTh2","svg-container":"Animator_svg-container__3jSql","rotate":"Animator_rotate__My2mk"};